import React from 'react'
import Box from '@mui/material/Box'

import {
  PROFILE_SECURITY_BORDER_COLOR,
  PROFILE_SECURITY_HEADING_COLOR,
  PROFILE_SECURITY_PRIMARY_SOFT,
  PROFILE_SECURITY_WHITE
} from '../constants/profileSecurityConstants'

export default function ProfileSecurityVerificationCodeInputs({
  digits,
  inputRefs,
  onChange,
  onKeyDown,
  onPaste,
  ariaLabelPrefix = 'Dígito',
  idPrefix = 'verification-code',
  focusColor
}) {
  return (
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
      {digits.map((digit, index) => (
        <Box
          key={`${idPrefix}-${index}`}
          component="input"
          id={`${idPrefix}-${index}`}
          ref={(node) => {
            inputRefs.current[index] = node
          }}
          value={digit}
          onChange={(event) => onChange(index, event.target.value)}
          onKeyDown={(event) => onKeyDown(index, event)}
          onPaste={onPaste}
          onFocus={(event) => event.target.select()}
          inputMode="numeric"
          autoComplete={index === 0 ? 'one-time-code' : 'off'}
          aria-label={`${ariaLabelPrefix} ${index + 1}`}
          maxLength={1}
          sx={{
            width: { xs: 42, sm: 52 },
            height: { xs: 48, sm: 56 },
            borderRadius: '12px',
            border: `1px solid ${PROFILE_SECURITY_BORDER_COLOR}`,
            textAlign: 'center',
            fontSize: 24,
            color: PROFILE_SECURITY_HEADING_COLOR,
            outline: 'none',
            backgroundColor: PROFILE_SECURITY_WHITE,
            '&:focus': {
              borderColor: focusColor,
              boxShadow: `0 0 0 3px ${PROFILE_SECURITY_PRIMARY_SOFT}`
            }
          }}
        />
      ))}
    </Box>
  )
}
